import { useEffect, useState } from "react";

const TIKTOK_UA = /musical_ly|trill_|BytedanceWebview|TikTok/i;

export const isTikTokInApp = (userAgent: string) => TIKTOK_UA.test(userAgent);

const TikTokInAppGuide = () => {
  // 첫 렌더는 항상 숨김 — UA 판별은 마운트 후 브라우저에서만 한다.
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isTikTokInApp(navigator.userAgent));
  }, []);

  if (!open) {
    return null;
  }

  return (
    <div
      className="tiktok_guide_backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tiktok_guide_title"
    >
      <svg
        className="tiktok_guide_arrow"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M12 21V4M5 11l7-7 7 7" />
      </svg>

      <div className="modal_container tiktok_guide_card">
        <p id="tiktok_guide_title" className="tiktok_guide_title">
          영상 속 제품을 확인하시려면
          <br />
          <strong>오른쪽 위 ⋯</strong> 를 눌러주세요
        </p>
        <hr className="tiktok_guide_divider" />
        <p className="tiktok_guide_desc">
          메뉴에서
          <br />
          <span className="tiktok_guide_badge">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M3 12h18M12 3c2.5 2.5 3.8 5.5 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.5-3.8-9S9.5 5.5 12 3z" />
            </svg>
            브라우저에서 열기
          </span>
          <br />
          를 선택하면 돼요
        </p>
        <button
          type="button"
          className="tiktok_guide_close"
          onClick={() => setOpen(false)}
        >
          닫고 여기서 볼게요
        </button>
      </div>
    </div>
  );
};

export default TikTokInAppGuide;
